// extracted by mini-css-extract-plugin
export default {"header":"manage-link_header__hpM-0","title":"manage-link_title__9uxDi","section":"manage-link_section__WR4pa"};